/**
 * LocalStorage utility functions for managing persisted form data
 */

export const GUARANTEE_FORM_KEY = 'guaranteeFormData'
export const REDUX_PREFIX = 'redux-'
export const REDUX_SESSION_PREFIX = 'redux-session-'

/**
 * Clear all persisted guarantee form data
 */
export const clearPersistedFormData = () => {
  try {
    // Clear guarantee form context data from localStorage
    localStorage.removeItem(GUARANTEE_FORM_KEY)
    
    // Clear all Redux persisted state from localStorage (legacy)
    const localStorageKeys = Object.keys(localStorage).filter(key => 
      key.startsWith(REDUX_PREFIX)
    )
    localStorageKeys.forEach(key => {
      localStorage.removeItem(key)
    })
    
    // Clear all Redux persisted state from sessionStorage (current)
    const sessionStorageKeys = Object.keys(sessionStorage).filter(key => 
      key.startsWith(REDUX_SESSION_PREFIX)
    )
    sessionStorageKeys.forEach(key => {
      sessionStorage.removeItem(key)
    })
  } catch (error) {
    console.error('Error clearing persisted form data:', error)
  }
}

/**
 * Save guarantee form data to localStorage
 */
export const saveFormData = (data: any) => {
  try {
    localStorage.setItem(GUARANTEE_FORM_KEY, JSON.stringify(data))
  } catch (error) {
    console.error('Error saving form data to localStorage:', error)
  }
}

/**
 * Retrieve guarantee form data from localStorage
 */
export const getFormData = () => {
  try {
    const data = localStorage.getItem(GUARANTEE_FORM_KEY)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error('Error retrieving form data from localStorage:', error)
    return null
  }
}

/**
 * Clear only the guarantee form data (not Redux state)
 */
export const clearFormData = () => {
  try {
    localStorage.removeItem(GUARANTEE_FORM_KEY)
  } catch (error) {
    console.error('Error clearing form data:', error)
  }
}
